import React, { useState, useEffect } from 'react';
import SEO from "../components/seo"
import LayoutsComponent from '../layouts/LayoutsComponent';
import Simulador from '../components/pages/SimuladorAfi'
import SimuladorV2 from '../components/pages/SimuladorV2Afi'
import {CircularProgress,Grid} from '@material-ui/core';

const SimuladorPage = ({ pageContext, location }) => {
  
return (
          <LayoutsComponent
            broker={pageContext.broker}
            layout={pageContext.layout}
            pageContext={pageContext}
            companyName={pageContext.company}
            location={location}
            render={() => (
              <>
                  <SEO title={pageContext.title} />    
                  <Simulador pageContext={pageContext} />                   
              </>
            )}
          />
        )
 
}

export default SimuladorPage
